/**
 * Quick price bands for the collection price filter: "Under X", "X - Y",
 * "Over Y". Most shoppers tap a band; few drag sliders.
 *
 * Bands are computed from the price inputs' CURRENT units, so they follow
 * collection-filter-market-price.js automatically: AED bands on /en-ae, INR
 * bands in India. On international markets this waits for the localizer's
 * data-market-price-localized mark before building, so bands can never
 * render in the wrong currency.
 *
 * Selecting a band writes the min/max inputs and dispatches the same input
 * event the theme's collection-filters-form already listens for, so
 * submission, URL building (including the INR back-conversion at the form
 * boundary) and re-rendering all run through existing code.
 */
(function () {
  'use strict';

  var PROCESSED_ATTR = 'data-price-presets-built';

  function isInternational() {
    if (!window.MarketConfig || typeof window.MarketConfig.getCurrentMarket !== 'function') return false;
    var market = window.MarketConfig.getCurrentMarket();
    var rate = market && market.config && Number(market.config.conversionRate);
    return !!(market && market.key !== 'default' && rate && rate > 0 && rate !== 1);
  }

  // Round to a friendly 1/2/2.5/5 x 10^n value.
  function niceRound(value) {
    if (value <= 0) return 0;
    var magnitude = Math.pow(10, Math.floor(Math.log10(value)));
    var normalized = value / magnitude;
    var nice;
    if (normalized < 1.5) nice = 1;
    else if (normalized < 2.25) nice = 2;
    else if (normalized < 3.75) nice = 2.5;
    else if (normalized < 7.5) nice = 5;
    else nice = 10;
    return nice * magnitude;
  }

  function currencyPrefix(holder) {
    var el = holder.querySelector('.filter__price__currency');
    var symbol = el ? el.textContent.trim() : '';
    if (!symbol) return '';
    return /[A-Za-z]$/.test(symbol) ? symbol + ' ' : symbol;
  }

  function build(holder) {
    if (holder.hasAttribute(PROCESSED_ATTR)) return;

    // International markets: wait until the market localizer has converted
    // this widget, so bands compute in the right currency.
    if (isInternational() && !holder.hasAttribute('data-market-price-localized')) return;

    var container = holder.querySelector('[data-price-presets]');
    var minInput = holder.querySelector('[data-field-price-min]');
    var maxInput = holder.querySelector('[data-field-price-max]');
    if (!container || !minInput || !maxInput) return;

    var max = parseFloat(maxInput.placeholder);
    if (!isFinite(max) || max <= 0) return;

    var t1 = niceRound(max / 3);
    var t2 = niceRound((max * 2) / 3);
    if (t2 <= t1) t2 = t1 * 2;
    if (t2 >= max) return; // range too small for meaningful bands

    holder.setAttribute(PROCESSED_ATTR, 'true');

    var symbol = currencyPrefix(holder);
    var currentMin = parseFloat(minInput.value);
    var currentMax = parseFloat(maxInput.value);

    var bands = [
      { label: 'Under ' + symbol + t1, min: '', max: String(t1) },
      { label: symbol + t1 + ' - ' + symbol + t2, min: String(t1), max: String(t2) },
      { label: 'Over ' + symbol + t2, min: String(t2), max: '' }
    ];

    container.innerHTML = '';
    bands.forEach(function (band) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'filter__price__preset';
      button.textContent = band.label;

      var bandMin = band.min === '' ? 0 : parseFloat(band.min);
      var bandMax = band.max === '' ? max : parseFloat(band.max);
      if (
        (isFinite(currentMin) ? currentMin : 0) === bandMin &&
        (isFinite(currentMax) ? currentMax : max) === bandMax
      ) {
        button.classList.add('is-active');
      }

      button.addEventListener('click', function () {
        minInput.value = band.min === '' ? '0' : band.min;
        maxInput.value = band.max === '' ? String(max) : band.max;
        // The theme's filters form listens for this and submits (debounced);
        // on international markets the formdata hook converts back to INR.
        maxInput.dispatchEvent(new Event('input', { bubbles: true }));
      });

      container.appendChild(button);
    });

    container.hidden = false;
  }

  function buildAll() {
    document.querySelectorAll('[data-range-holder]').forEach(build);
  }

  function init() {
    buildAll();
    // The sidebar's HTML is replaced after every filter change; the localizer
    // marks holders with an attribute when it finishes, so watch both.
    var observer = new MutationObserver(buildAll);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-market-price-localized']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
